import { combineReducers } from "redux";
import getSummaryDataReducer from "./summaryDataReducer";

const summaryDataReducer = combineReducers({
    summaryData: getSummaryDataReducer});

export default summaryDataReducer;